import { Instance, types } from 'mobx-state-tree';
import { FormState, FieldState } from 'formstate';
import { AgreementDocument } from '../agreement/model/AgreementDocument';
import { required } from '../shared/validators/RequiredValidator';

export const MemberAgreementEntryStore = types
  .model({
    text: types.maybe(types.string),
    scrollText: types.maybe(types.string),
    documents: types.array(AgreementDocument),
    previouslyAcceptedThisAgreement: types.boolean,
    agreementAccepted: types.optional(types.boolean, false)
  })
  .views(self => ({
    get reactForm() {
      return new FormState({
        agreementAccepted: new FieldState(self.agreementAccepted).disableAutoValidation().validators(required())
      });
    },
    canProceed() {
      return !this.reactForm.hasError;
    },
    getDataToSubmit() {
      return { agreementAccepted: this.reactForm.$.agreementAccepted.value };
    }
  }))
  .actions(self => ({
    validateForm() {
      return self.reactForm.validate();
    },
    updateAgreementWithPreviouslyAccepted() {
      self.agreementAccepted = self.previouslyAcceptedThisAgreement;
    }
  }))
  .named('MemberAgreementEntryStore');

export type MemberAgreementEntryStore = Instance<typeof MemberAgreementEntryStore>;
